import React, { useEffect } from "react";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { observeTransaction, startPortfolioNotifications, clearPortfolioSession } from "./utils/portfolioCache";
import { useHistory, useLocation } from "react-router-dom";
import Mantainence from "./containers/Maintanence/Maintanence";
import { getRequiredData } from "./redux/apicalltemplate";
import { userApis } from "../src/redux/api";
import AnchorUal from "./Anchor";
import { Notice } from "./components/Notice/Notice";

import LoadingOverlay from "./components/LoadingOverlay/LoadingOverlay";
import { setOverlayLoader } from "./context";
import { WidgetChat } from "./components/ChatWidget/Chat";

function App()
{
  const dispatch = useDispatch();
  const location = useLocation();
  const portfolioToken = localStorage.getItem("token");
  useEffect(() => startPortfolioNotifications(), []);
  useEffect(() => { if (!portfolioToken) clearPortfolioSession(); }, [portfolioToken]);
  // const { loginloading } = useSelector((state) => state.user);
  // const [isMaintainence, setIsMaintainence] = useState(true);
  // const { cartdata } = useSelector((state) => state.crowdsale);

  // ------------------------FREIGHTER SECTION----------------------------------------------
  // const getPk = async () =>
  // {
  //   console.log("-----------------GET PK---------------------")
  //   const publicKey = await getUserInfo();
  //   console.log(publicKey)
  //   return publicKey;
  // }
  // getPk("hiii kaus")
  // const connect = async () =>
  // {
  //   console.log(" ============================================================== HELLO ============================")
  //   await setAllowed();

  // }

  useEffect(() =>
  {
    window.process = window.process || { env: {} };
    window.process.env = window.process.env || {};
  }, []);

  // Reset overlay loader on any unhandled error/rejection
  useEffect(() => {
    const handleError = () => {
      dispatch(setOverlayLoader(false));
    };
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, [dispatch]);


  let maintanence = false;
  //
  const history = useHistory();
  ///axios interceptors-----------for handlings error---
  ///axios interceptors-----------for handlings error---
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => {
        if (response.config?.url?.startsWith(process.env.REACT_APP_BASE_URL)) {
          observeTransaction(response.data, response.config.method, response.config.headers?.['x-auth-token']);
        }
        return response;
      },
      (error) => {
        //Unable to get access token
        if (
          error.response &&
          error.response.status === 401 &&
          error.response.data &&
          error.response.data &&
          ((error.response.data.error &&
            error.response.data.error === "invalid_token") ||
            error.response.data.message === "Unauthorised user." ||
            error.response.data.message === "Unknown device." ||
            error.response.data.message === "Invalid or expired token")
        ) {
          if (localStorage.getItem("token")) {
            localStorage.clear();
            clearPortfolioSession();
            history.push("/login");
          }
        }

        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [history]);

  React.useEffect(() => {
    const fetchCsrf = async () => {
       await getRequiredData("GET", userApis?.GET_CSRF);
    };
    fetchCsrf();
  }, []);


  const { loadertext, overlayLoader } = useSelector((state => state.appData));

  return (
    <div className={`tab-content ${location.pathname === "/login" ? "tm-auth-shell" : ""}`}>
      <LoadingOverlay
        className="row m-auto w-100"
        active={overlayLoader}
        spinner
        text={loadertext}
      >

        <ToastContainer limit={2} />

        {maintanence ? (
          <Mantainence />
        ) : (
          <div className="content">
            {/* {localStorage.getItem("token") ? <Header /> : <div></div>} */}
            {/* <Routes cartdata={cartdata} /> */}
            {/* <button onClick={connect}>Hello</button>
            <button onClick={getPk}>showpublickey</button> */}
            <AnchorUal />
          </div>
        )}
        <Notice />
        {
          <WidgetChat />
        }
      </LoadingOverlay>
    </div>
  );
}

export default App;
